import { Box, Text } from "@chakra-ui/layout";
import { Modal } from "antd";
import {
  PessoaDto,
  TipoUnidadePessoaEnum,
} from "core/features/unidades/typings/unidade";
import useSavePessoaUnidade from "core/features/unidades/useSavePessoaUnidade";
import useUnidadePessoa from "core/features/unidades/useUnidadePessoa";
import { showErrorAxios } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "components/Button/FooterModal";
import { useLoading } from "components/GlobalLoading";
import FormMoradorUnidade from "./FormMoradorUnidade";

interface ModalCadastroPessoaUnidadeProps {
  changeProprietario?: boolean;
  isOpen: boolean;
  unidadeId: string;
  id?: string | null;
  tenantId: string;
  onClose: () => any;
  onSaved: any;
}

const defaultValues: Partial<PessoaDto> = {
  permissoes: [],
  contatos: [],
  tipoUnidadePessoaId: TipoUnidadePessoaEnum.Proprietario,
  enviarEmailAcesso: false,
};

function ModalCadastroPessoaUnidade({
  changeProprietario,
  isOpen,
  unidadeId,
  id,
  onClose,
  onSaved,
  tenantId,
}: ModalCadastroPessoaUnidadeProps) {
  const [registerAnother, setRegisterAnother] = useState(false);

  const { data: pessoa, isFetching: isLoadingPessoa } = useUnidadePessoa(
    unidadeId,
    id
  );
  const [loadingUpload, setLoadingUpload] = useState(false);

  const { mutate: handleSave, isLoading } = useSavePessoaUnidade(unidadeId, id);

  const handleModalSubmit = async (data: PessoaDto) => {
    data.locatario =
      data.tipoUnidadePessoaId === TipoUnidadePessoaEnum.Locatario;
    data.proprietario =
      data.tipoUnidadePessoaId === TipoUnidadePessoaEnum.Proprietario;
    data.trocarProprietario = !!changeProprietario;

    data.contatos = data.contatos ?? [];

    handleSave(data, {
      onSuccess: () => {
        setTimeout(onSaved, 50);
      },
      onError: (err) => showErrorAxios(err),
    });
  };

  const { control, handleSubmit, watch, reset, trigger, setValue } =
    useForm<PessoaDto>({
      reValidateMode: "onChange",
      mode: "onTouched",
      defaultValues: {
        moradorExistente: null,
        contatos: [],
        enviarEmailAcesso: false,
      },
    });

  useLoading(isLoading || isLoadingPessoa);

  useEffect(() => {
    if (pessoa) {
      const form = {
        ...pessoa,
        contatos: Array.isArray(pessoa.contatos) ? pessoa.contatos : [],
      };

      reset({ ...defaultValues, ...form, moradorExistente: "n" });
    } else {
      reset(defaultValues);
    }
  }, [pessoa, reset]);

  return (
    <Modal
      destroyOnClose
      width="900px"
      footer={
        <FooterModal
          registerAnother={registerAnother}
          setRegisterAnother={setRegisterAnother}
          onSubmit={handleSubmit(handleModalSubmit)}
          onClose={onClose}
          isLoadingSave={isLoading || loadingUpload}
        />
      }
      centered
      bodyStyle={{
        height: "max(80vh, 400px)",
        overflow: "auto",
        paddingBottom: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
      title={
        <Text as="h3" fontSize={20}>
          {changeProprietario
            ? "Trocar proprietário"
            : pessoa?.id
            ? "Editar"
            : "Cadastrar nova"}{" "}
          pessoa
        </Text>
      }
    >
      <Box>
        <form onSubmit={(ev) => handleSubmit(handleModalSubmit)(ev)}>
          <>
            {!isLoadingPessoa ? (
              <FormMoradorUnidade
                hiddenTipo={!!changeProprietario}
                control={control}
                watch={watch}
                unidadeId={unidadeId}
                tenantId={tenantId}
                trigger={trigger}
                setField={setValue}
                id={id}
                setLoadingUpload={setLoadingUpload}
              />
            ) : null}
          </>
        </form>
      </Box>
    </Modal>
  );
}

export default ModalCadastroPessoaUnidade;
